"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "FloatingPortal", {
  enumerable: true,
  get: function () {
    return _react2.FloatingPortal;
  }
});
exports.GenesisFloatingPortal = exports.GenesisFloatingFocusManager = exports.FocusManager = void 0;
var React = _interopRequireWildcard(require("react"));
var _react2 = require("@floating-ui/react");
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _qa = require("../../utils/qa");
var _FocusManagerModule = _interopRequireDefault(require("./FocusManager.module.css"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const GenesisFloatingPortal = props => /*#__PURE__*/(0, _jsxRuntime.jsx)(_react2.FloatingPortal, {
  ...props
});
exports.GenesisFloatingPortal = GenesisFloatingPortal;
const GenesisFloatingFocusManager = props => /*#__PURE__*/(0, _jsxRuntime.jsx)(_react2.FloatingFocusManager, {
  ...props
});

// Export FloatingPortal for external use
exports.GenesisFloatingFocusManager = GenesisFloatingFocusManager;
const FocusManager = props => {
  const {
    refs,
    context
  } = (0, _react2.useFloating)({
    open: true
  });
  const {
    classNames,
    children,
    initialFocus = -1,
    returnFocus = true,
    modal = true,
    guards = true,
    testId,
    ...restFloatingFocusManagerProps
  } = props;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react2.FloatingFocusManager, {
    context: context,
    initialFocus: initialFocus,
    modal: modal,
    guards: guards,
    returnFocus: returnFocus,
    ...restFloatingFocusManagerProps,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      ref: refs.setFloating,
      "data-testid": (0, _qa.generateTestId)({
        base: testId,
        slot: 'focusManager'
      }),
      className: (0, _classify.default)(_FocusManagerModule.default.wrapper, classNames?.wrapper),
      children: children
    })
  });
};
exports.FocusManager = FocusManager;